export const isValidUrl = (url: string) => {
  return new RegExp(
    /^(?:https?:\/\/.)?(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b[-a-zA-Z0-9@:%_+.,~#?&/=]*$/
  ).test(url);
};
